import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useUniqueId from "./useUniqueId";
import Confirm from "../UI/Confirm/Confirm";
const DEFAULT_CONFIG = {
    isInModal: false,
};
/**
 * Require user confirmation before performing an action.
 *
 * Returns an tuple whose first value is confirm funciton which accepts an optional string
 * parameter as a prompt for the message and returns a `Promise<boolean>`
 * where the resolved value indicates whether the user confirmed or cancelled (true indicates confirmed)
 *
 * The second value of the tuple is an array of Modal react nodes.  Should be rendered somewhere in
 * the calling component.
 *
 */
function useConfirmation(config = {}) {
    const [id] = useUniqueId();
    const [modals, setModals] = React.useState([]);
    const [modalsOpen, setModalsOpen] = React.useState([]);
    const confirm = React.useMemo(() => (confirmContent) => new Promise((res) => {
        setModalsOpen((mO) => mO.concat([true]));
        setModals((m) => m.concat((open) => (_jsx(Confirm, { isOpen: open, modalId: id + m.length, confirmationText: confirmContent, onModalClosed: (confirmed) => {
                setModalsOpen((mO) => mO.map((isOpen, i) => (i === m.length ? false : isOpen)));
                res(confirmed);
            }, confirmButtonLabel: config.confirmButtonLabel, cancelButtonLabel: config.cancelButtonLabel, confirmButtonClassName: config.confirmButtonClassName }, m.length))));
    }), [config, id]);
    return [confirm, modals.map((modal, index) => modal(modalsOpen[index]))];
}
export default useConfirmation;
